import './AllNewsDisplayer.css';
import React from 'react';
import SingleOffer from '../SingleOffer/SingleOffer';
import { useOffersToDisplay, useDetailedOffer } from '../../data/GlobalStates';
import { useAtom } from 'jotai';

const AllNewsDisplayer = () => { 
  const [OffersToDisplay] = useAtom(useOffersToDisplay);
  const [DetailedOffer, setDetailedOffer] = useAtom(useDetailedOffer);

  // Funkcja pomocnicza do formatowania daty w postaci "MMMM YYYY"
  const formatDateHeader = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('default', { month: 'long', year: 'numeric' });
  };

  // Trzymanie poprzedniego miesiąca i roku, żeby wiedzieć, kiedy wstawić śródtytuł
  let prevMonthYear = '';

  return (
    <div id='AllNewsDisplayerMainDiv'>
      {OffersToDisplay.length ? 
        OffersToDisplay.map((offer, index) => {
          const currentMonthYear = formatDateHeader(offer.addDate);

          // Jeśli zmienił się miesiąc/rok, wstaw śródtytuł
          const showHeader = currentMonthYear !== prevMonthYear;
          prevMonthYear = currentMonthYear;

          return (
            <React.Fragment key={offer.id}>
              {showHeader && (
                <h3 className="offer-date-header">{currentMonthYear}</h3>
              )}
              <SingleOffer
                Images={offer.ImagesUrls || []}
                offer={offer}
                setDetailedOffer={setDetailedOffer}
                dataIndex={index} 
                id={`offer-${index}`}
              />
            </React.Fragment>
          );
        }) 
      : ''}
    </div>
  );
};

export default AllNewsDisplayer;